import React from 'react';
import { motion } from 'framer-motion';

const ServiceCard = ({ 
  icon: Icon, 
  title, 
  description, 
  features = [], 
  className = '',
  delay = 0 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true }}
      whileHover={{ y: -5 }}
      className={`bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 ${className}`}
    >
      <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-xl mb-6">
        <Icon className="w-8 h-8 text-primary" />
      </div>
      
      <h3 className="text-xl font-semibold text-secondary mb-4">{title}</h3>
      
      <p className="text-gray-600 mb-6 leading-relaxed">{description}</p>
      
      {features.length > 0 && (
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center text-sm text-gray-600">
              <div className="w-2 h-2 bg-primary rounded-full mr-3 flex-shrink-0"></div>
              {feature}
            </li>
          ))}
        </ul>
      )}
    </motion.div>
  );
};

export default ServiceCard;
